'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = {
	_$Toolbar: {
		displayName: 'Toolbar'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Toolbar = (function (_Component) {
	_inherits(Toolbar, _Component);

	function Toolbar() {
		_classCallCheck(this, _Toolbar);

		_Component.apply(this, arguments);
	}

	Toolbar.prototype.render = function render() {
		return _react2['default'].createElement(
			'div',
			{ className: 'formtoolbar' },
			this.props.buttons,
			_react2['default'].createElement(
				'h3',
				null,
				this.props.title.title ? this.props.title.title : this.props.title
			),
			this.props.title.subtitle && _react2['default'].createElement(
				'div',
				null,
				this.props.title.subtitle
			),
			_react2['default'].createElement('hr', null)
		);
	};

	var _Toolbar = Toolbar;
	Toolbar = _wrapComponent('_$Toolbar')(Toolbar) || Toolbar;
	return Toolbar;
})(_Component2['default']);

exports['default'] = Toolbar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Toolbar.js
 ** module id = 92
 ** module chunks = 2
 **/